module.exports = __webpack_public_path__ + "static/media/img-about.ca1bcd24.jpg";